import * as ActionType from "./host.type";

const initialState = {
  host: [],
  dialog: false,
  dialogueData: null,
  dialogMode: "", 
  hostProfile: {},
  hostHistory: [],
  totalCoin: 0,
  total: 0,
};

export const hostReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_HOST:
      return {
        ...state,
        host: action.payload,
      };

    case ActionType.CREATE_HOST:
      return {
        ...state,
        host: [action.payload, ...state.host],
      };

    case ActionType.OPEN_HOST_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogMode: action.payload?.mode,
        dialogueData: action.payload?.data || null,
      };

    case ActionType.CLOSE_HOST_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogueData: null,
      };

   case ActionType.EDIT_HOST:
  // Check if payload exists and has _id
  if (!action.payload || !action.payload.id || !action.payload.data) return state;

  return {
    ...state,
    host: state.host.map((item) =>
      item._id === action.payload.id ? action.payload.data : item
    ),
    hostProfile:
      state.hostProfile && state.hostProfile._id === action.payload.id
        ? action.payload.data
        : state.hostProfile,
  };


    case ActionType.GET_HOST_PROFILE:
      return {
        ...state,
        hostProfile: action.payload,
      };

    case ActionType.HOST_DISABLE:
      return {
        ...state,
        host: state.host.map((data) =>
          data._id === action.payload.id ? action.payload.data : data
        ),
        hostProfile: action.payload.data,
      };

    case ActionType.GET_HOST_HISTORY:
      return {
        ...state,
        hostHistory: action.payload.history,
        totalCoin: action.payload.totalCoin,
        total: action.payload.total,
      };

    case ActionType.UPDATE_HOST_COIN:
      return {
        ...state,
        host: action.payload.host,
      };

    default:
      return state;
  }
};
